import React from 'react';
import {createPortal} from 'react-dom';

const ToolTipPortal = ({
  targetRef,
  toolTipArrowStyle = {},
  toolTipContainerStyle = {},
  toolTipLabelStyle = {},
  toolTipPosition,
  toolTipTxt = '',
}) => {
  const getPosition = () => {
    if (targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      let position = {x: 0, y: 0};
      switch (toolTipPosition) {
        case 'right':
          position = {
            x: rect.right, // Center of the element horizontally
            y: rect.top + rect.height / 2, // Top of the element
          };
          break;
        case 'left':
          position = {
            x: rect.left, // Center of the element horizontally
            y: rect.top + rect.height / 2, // Top of the element
          };
          break;
        case 'top':
          position = {
            x: rect.left + rect.width / 2, // Center of the element horizontally
            y: rect.top, // Top of the element
          };
          break;
        case 'bottom':
          position = {
            x: rect.left + rect.width / 2, // Center of the element horizontally
            y: rect.bottom, // Top of the element
          };
          break;
        case 'bottom-left':
          position = {
            x: rect.left - rect.width / 2, // Center of the element horizontally
            y: rect.bottom, // Top of the element
          };
          break;
        case 'top-left':
          position = {
            x: rect.left - rect.width / 2, // Center of the element horizontally
            y: rect.top, // Top of the element
          };
          break;
        default:
          break;
      }
      return position;
    }
    return {
      x: 0,
      y: 0,
    };
  };
  const position = getPosition();
  const style = {
    position: 'absolute',
    top: position.y,
    left: position.x,
    width: toolTipTxt.length <= 20 ? 140 : 220,
    // transform: 'translate(0%, -50%)', // Center it on the cursor and appear above the cursor
    zIndex: 100,
  };
  return createPortal(
    <div
      style={{...style, ...toolTipContainerStyle}}
      id="tooltip"
      className={toolTipPosition}>
      <div className="tooltip-arrow" style={toolTipArrowStyle} />
      <div
        className="tooltip-label"
        style={{
          width: toolTipTxt.length <= 20 ? 140 : 220,
          ...toolTipLabelStyle,
        }}>
        {toolTipTxt}
      </div>
    </div>,
    document.getElementById('et-top-level-popup-portal-wrapper'), // Injecting into the body directly
  );
};

export default ToolTipPortal;
